import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Format number with comma separators for thousands, millions, etc.
 * Only shows integer part, no decimals
 * @param value - Number or string to format
 * @returns Formatted string with comma separators (e.g., "1,234,567")
 */
export function formatNumber(value: string | number | undefined | null): string {
  if (value === undefined || value === null || value === "") {
    return "0";
  }
  
  // Parse the value to number
  let numValue: number;
  if (typeof value === "string") {
    // Remove any non-numeric characters except decimal point
    const cleaned = value.replace(/[^\d.]/g, "");
    numValue = parseFloat(cleaned);
  } else {
    numValue = value;
  }
  
  // Check if valid number
  if (isNaN(numValue)) {
    return "0";
  }
  
  // Round down to integer (no decimals)
  const integerValue = Math.floor(numValue);
  
  // Format with comma separators
  return integerValue.toLocaleString("en-US");
}
